var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsNumber, IsString } from 'class-validator';
export class ActivityPointLevel {
    name;
    lvl;
    minPoints;
    maxPoints;
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], ActivityPointLevel.prototype, "name", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], ActivityPointLevel.prototype, "lvl", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], ActivityPointLevel.prototype, "minPoints", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], ActivityPointLevel.prototype, "maxPoints", void 0);
export const activityPointLevels = [
    { name: 'Anfänger', lvl: 1, minPoints: 0, maxPoints: 99 },
    { name: 'Aktiv', lvl: 2, minPoints: 100, maxPoints: 199 },
    { name: 'Motiviert', lvl: 3, minPoints: 200, maxPoints: 299 },
    { name: 'Entschlossen', lvl: 4, minPoints: 300, maxPoints: 399 },
    { name: 'Energiegeladen', lvl: 5, minPoints: 400, maxPoints: 499 },
    { name: 'Vital', lvl: 6, minPoints: 500, maxPoints: 599 },
    { name: 'Fit', lvl: 7, minPoints: 600, maxPoints: 699 },
    { name: 'Sportlich', lvl: 8, minPoints: 700, maxPoints: 799 },
    { name: 'Durchtrainiert', lvl: 9, minPoints: 800, maxPoints: 899 },
    { name: 'Athletisch', lvl: 10, minPoints: 900, maxPoints: 999 },
    { name: 'Powerhouse', lvl: 11, minPoints: 1000, maxPoints: 1099 },
    { name: 'Champion', lvl: 12, minPoints: 1100, maxPoints: 1199 },
    { name: 'Meisterhaft', lvl: 13, minPoints: 1200, maxPoints: 1299 },
    { name: 'Legende', lvl: 14, minPoints: 1300, maxPoints: 1399 },
    { name: 'Elite', lvl: 15, minPoints: 1400, maxPoints: 1499 },
    { name: 'Großmeister', lvl: 16, minPoints: 1500, maxPoints: 1599 },
    { name: 'Ikone', lvl: 17, minPoints: 1600, maxPoints: 1699 },
    { name: 'Überragend', lvl: 18, minPoints: 1700, maxPoints: 1799 },
    { name: 'Titan', lvl: 19, minPoints: 1800, maxPoints: 1899 },
    { name: 'Unaufhaltbar', lvl: 20, minPoints: 1900, maxPoints: 1999 },
    { name: 'Unbesiegbar', lvl: 21, minPoints: 2000, maxPoints: 2099 },
    { name: 'Übermenschlich', lvl: 22, minPoints: 2100, maxPoints: Infinity },
];
export const getCurrentActivityPointLevel = (points) => {
    return (activityPointLevels.find((level) => points >= level.minPoints && points <= level.maxPoints) ||
        activityPointLevels[0]);
};
export const getPreviousActivityPointLevel = (points) => {
    const currentLevel = activityPointLevels.find((level) => points >= level.minPoints && points <= level.maxPoints);
    if (currentLevel) {
        const currentIndex = activityPointLevels.indexOf(currentLevel);
        if (currentIndex > 0) {
            return activityPointLevels[currentIndex - 1];
        }
    }
    return null;
};
//# sourceMappingURL=activity-point-levels.const.js.map